import { Box, styled } from '@mui/material';
import classnames from 'classnames';

import { HubsViewMode, ResourceRegionType } from '#shared';

import { renderRegionCards } from './renderRegionCards';

import type { HubReportStatus } from '#entities';
import type { DrawerViewType } from '../ResourceDrawer';

const PREFIX = 'TSMED-HubStatusCardList';
const classes = {
  root: `${PREFIX}-root`,
  vertical: `${PREFIX}-vertical`,
  horizontal: `${PREFIX}-horizontal`,
};

interface HubStatusCardListProps {
  items: HubReportStatus[];
  alignment?: 'vertical' | 'horizontal';
  className?: string;
  region: ResourceRegionType;
  surgeonGroups?: HubReportStatus['staffInfo'][];
  onClickHub: (id: string, type: DrawerViewType) => void;
  onClickSurgeon: (index: number) => void;
  hubsViewMode?: HubsViewMode;
}

const Root = styled(Box)(({ theme: { breakpoints, spacing } }) => ({
  display: 'flex',
  width: 'fit-content',
  gap: spacing(3),
  padding: spacing(1, 2),

  [`&.${classes.vertical}`]: {
    flexDirection: 'column',

    [breakpoints.down('xl')]: {
      gap: spacing(2),
    },
  },

  [`&.${classes.horizontal}`]: {
    flexDirection: 'row',
  },
}));

/**
 * A container component that displays a list of HubStatusCard components
 * with support for vertical or horizontal alignment.
 */
export const HubStatusCardList = ({
  alignment = 'vertical',
  className,
  items,
  region,
  surgeonGroups = [],
  onClickHub,
  onClickSurgeon,
  hubsViewMode,
}: HubStatusCardListProps) => (
  <Root className={classnames(classes[alignment], className)}>
    {renderRegionCards(
      region,
      surgeonGroups,
      items,
      onClickHub,
      onClickSurgeon,
      hubsViewMode,
    )}
  </Root>
);
